// src/utils/metaPixel.js
// Helpers de eventos del Meta Pixel (ID 26824668643826278).
// El pixel base + PageView se inicializan en public/index.html.
// Estos helpers disparan eventos puntuales con guard para no romper si fbq
// no cargó (adblock, navegador sin JS de terceros, etc.).

export function trackViewContent() {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', 'ViewContent');
  }
}

export function trackInitiateCheckout() {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', 'InitiateCheckout');
  }
}

// PageView manual — necesario para SPA routes que se montan después del
// PageView inicial de index.html. Llamarlo en useEffect al mount de la
// landing /senales-gratis para que aparezca como conversión en Meta Ads.
export function trackPageView() {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', 'PageView');
  }
}

// Lead: usuario manifestó intención (click CTA Telegram en la landing free).
// Llevamos también un trackCustom 'JoinTelegramFree' para granularidad
// de funnels específicos sin perder el evento estándar 'Lead' (que sirve
// para optimización de campañas).
export function trackJoinTelegramFree() {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', 'Lead', { content_name: 'JoinTelegramFree' });
    window.fbq('trackCustom', 'JoinTelegramFree');
  }
}
